// extracted by mini-css-extract-plugin
export var legendIndicator = "_d6-1";
export var legendRight = "_d6-0";